import { faGlobe, faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import ExpandableContent from 'Component/ExpandableContent';
import Image from 'Component/Image';
import Link from 'Component/Link';
import Loader from 'Component/Loader';
import MenuItem from 'Component/MenuItem';
import StoreSwitcher from 'Component/StoreSwitcher';
import {
    Menu as SourceMenu
} from 'SourceComponent/Menu/Menu.component';
import { isSignedIn } from 'Util/Auth';
import { getSortedItems } from 'Util/Menu';

import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import './Menu.override.style';

/** @namespace Elganso/Component/Menu/Component */
export class MenuComponent extends SourceMenu {
    static propTypes = {
        ...this.propTypes,
        activeOption: PropTypes.number
    };

    onClickMenuArrowLeft = this.onClickMenuArrowLeft.bind(this);

    onClickMenuArrowRight = this.onClickMenuArrowRight.bind(this);

    onClickMenuArrowLeft() {
        const { clickMenuArrowLeft } = this.props;
        clickMenuArrowLeft();
    }

    onClickMenuArrowRight() {
        const { clickMenuArrowRight } = this.props;
        clickMenuArrowRight();
    }

    renderAdditionalInformation() {
        return null;
    }

    renderSubLevelItems(item, isSecondLevel) {
        const {
            handleSubcategoryClick,
            activeMenuItemsStack,
            onCategoryHover,
            closeMenu
        } = this.props;

        const { item_id, children } = item;

        const childrenArray = Object.values(children);
        const subcategoryMods = { type: 'subcategory', isSecondLevel };

        if (childrenArray.length) {
            return (
                <div
                  key={ item_id }
                  onClick={ (e) => handleSubcategoryClick(e, item) }
                  tabIndex="0"
                  role="button"
                  onKeyUp={ () => {} }
                >
                    <MenuItem
                      activeMenuItemsStack={ activeMenuItemsStack }
                      item={ item }
                      itemMods={ { ...subcategoryMods, isExpanded: activeMenuItemsStack.includes(item_id) } }
                      onCategoryHover={ onCategoryHover }
                      closeMenu={ closeMenu }
                      isExpandable
                    />
                    { this.renderSubLevel(item) }
                </div>
            );
        }

        return (
            <div
              block="Menu"
              elem="SubItemWrapper"
              key={ item_id }
              onClick={ this.stopPropagation }
              role="button"
              tabIndex="-1"
              onKeyUp={ () => {} }
            >
                <MenuItem
                  activeMenuItemsStack={ activeMenuItemsStack }
                  item={ item }
                  itemMods={ subcategoryMods }
                  closeMenu={ closeMenu }
                  isLink
                />
                { this.renderDesktopSubLevel(item) }
            </div>
        );
    }

    renderSubLevel(category, isSecondLevel = false) {
        const { activeMenuItemsStack } = this.props;
        const { item_id, children, item_class } = category;
        const childrenArray = getSortedItems(Object.values(children));
        const isVisible = activeMenuItemsStack.includes(item_id);
        const subcategoryMods = { type: 'subcategory' };

        return (
            <div
              block="Menu"
              elem="SubMenu"
              mods={ { isVisible } }
              key={ item_id }
            >
                <div
                  block="Menu"
                  elem="ItemList"
                  mods={ { ...subcategoryMods, item_class } }
                >
                    { childrenArray.map((item) => this.renderSubLevelItems(item, isSecondLevel)) }
                </div>
            </div>
        );
    }

    renderFirstLevelItems(item) {
        const {
            activeMenuItemsStack,
            handleSubcategoryClick,
            onCategoryHover,
            closeMenu
        } = this.props;

        const { children, item_id } = item;
        const itemMods = { type: 'main' };

        const hasChild = Object.keys(children).length > 0;

        return (
            <div
              onClick={ (e) => handleSubcategoryClick(e, item) }
              tabIndex="0"
              block="Menu"
              elem="SubCatLink"
              role="button"
              onKeyUp={ () => {} }
            >
                <MenuItem
                  activeMenuItemsStack={ activeMenuItemsStack }
                  item={ item }
                  itemMods={ { ...itemMods, isExpanded: activeMenuItemsStack.includes(item_id) } }
                  onCategoryHover={ onCategoryHover }
                  closeMenu={ closeMenu }
                  isLink={ !hasChild }
                  isExpandable={ hasChild }
                />
                { this.renderSubLevel(item, true) }
            </div>
        );
    }

    renderTopLevel() {
        const { menu } = this.props;
        const categoryArray = Object.values(menu);

        if (!categoryArray.length) {
            return null;
        }

        const [{ children, title: mainCategoriesTitle }] = categoryArray;
        const childrenArray = getSortedItems(Object.values(children));

        return (
            <div block="Menu" elem="MainCategories">
                    { this.renderAdditionalInformation(true) }
                    <ul
                      block="Menu"
                      elem="ItemList"
                      mods={ { type: 'main' } }
                      aria-label={ mainCategoriesTitle }
                    >
                        { childrenArray.map(this.renderFirstLevel.bind(this)) }
                    </ul>
            </div>
        );
    }

    renderFirstLevel(item) {
        const { item_id } = item;

        return (
            <li
              block="Menu"
              elem="Item"
              key={ item_id }
            >
                { this.renderFirstLevelItems.call(this, item) }
            </li>
        );
    }

    renderItemYB(item) {
        const {
            title, url, item_id, etiqueta, title_image
        } = item;
        const { activeOption, clickItem } = this.props;

        if (title_image) {
            return (
                <Link
                  to={ url }
                  block="Menu"
                  elem="Link"
                  id={ item_id }
                  onClick={ () => clickItem(item_id) }
                >
                    <figcaption
                      block="Menu"
                      elem="ItemCaption"
                      className={ item_id === activeOption ? 'activeOption' : '' }
                    >
                        <Image src={ title_image } />
                        <span className={ etiqueta ? 'menu_etiqueta_text_categoria' : 'menu_etiqueta_text_categoria_oculta' }>{ etiqueta }</span>
                    </figcaption>
                </Link>

            );
        }

        return (
            <Link
              to={ url }
              block="Menu"
              elem="Link"
              id={ item_id }
              onClick={ () => clickItem(item_id) }
            >
                <figcaption
                  block="Menu"
                  elem="ItemCaption"
                  className={ item_id === activeOption ? 'activeOption' : '' }
                >
                    { title }
                    <span className={ etiqueta ? 'menu_etiqueta_text_categoria' : 'menu_etiqueta_text_categoria_oculta' }>{ etiqueta }</span>
                </figcaption>
            </Link>
        );
    }

    renderNoLinkItemYB(item, clases = null) {
        const { title, etiqueta, title_image } = item;

        if (title_image) {
            return (
                <figcaption
                  block="Menu"
                  elem="ItemCaption"
                  className={ clases || '' }
                >
                    <Image src={ title_image } />
                    <span className={ etiqueta ? 'menu_etiqueta_text_categoria' : 'menu_etiqueta_text_categoria_oculta' }>{ etiqueta }</span>
                </figcaption>
            );
        }

        return (
            <figcaption
              block="Menu"
              elem="ItemCaption"
              className={ clases || '' }
            >
                { title }
                <span className={ etiqueta ? 'menu_etiqueta_text_categoria' : 'menu_etiqueta_text_categoria_oculta' }>{ etiqueta }</span>
            </figcaption>
        );
    }

    renderChildrenItemsYB(items) {
        return (
            <ul>
                { items.map(this.renderFirstLevelYB.bind(this)) }
            </ul>
        );
    }

    renderFirstLevelYB(item) {
        const { item_id, children = [], item_class } = item;
        const { clickExpandable, activeOption } = this.props;

        if (children.length > 0) {
            let isActive = false;

            children.forEach((el) => {
                if (el.item_id === activeOption) {
                    isActive = true;
                }
            });

            if (item_class !== null && item_class.includes('menu-abierto')) {
                isActive = true;
            }

            return (
                <li
                  block="Menu"
                  elem="Item"
                  key={ item_id }
                  className={ (item_class || '') + (isActive ? ' activeOption' : '') }
                  onClick={ () => clickExpandable(item_id) }
                  onKeyUp={ () => {} }
                >
                    <ExpandableContent
                      heading={ this.renderNoLinkItemYB(item) }
                      mix={ { block: 'SubMenu', elem: 'Expandable' } }
                      isContentExpanded={ isActive }
                    >
                        { this.renderChildrenItemsYB(children) }
                    </ExpandableContent>
                </li>
            );
        }

        return (
                <li
                  block="Menu"
                  elem="Item"
                  key={ item_id }
                  className={ item_class || '' }
                >
                    { this.renderItemYB(item) }
                </li>
        );
    }

    renderSliderPadresYB(item) {
        const { item_id, item_class, children = [] } = item;
        const { clickCatPadre, catHijaPadreMostrada } = this.props;

        const clases = (item_class || '') + (item_id === catHijaPadreMostrada ? ' mostrando' : '');

        return (
            <SwiperSlide key={ item_id }>
                <div
                  id={ item_id }
                  block="Menu"
                  elem="Item"
                  key={ item_id }
                  className={ clases }
                  onClick={ () => clickCatPadre(item_id) }
                  onKeyUp={ () => {} }
                >
                    { children.length > 0 ? this.renderNoLinkItemYB(item, item_class) : this.renderItemYB(item) }
                </div>
            </SwiperSlide>
        );
    }

    renderCatHijasPadres(cat) {
        const { item_id, children = [] } = cat;
        const { catHijaPadreMostrada } = this.props;

        if (children.length > 0) {
            return (
                <ul
                  id={ item_id }
                  key={ item_id }
                  block="Menu"
                  elem="ItemList"
                  mods={ { type: 'main' } }
                  className={ catHijaPadreMostrada !== cat.item_id ? 'oculta' : '' }
                >
                    { children.map(this.renderFirstLevelYB.bind(this)) }
                </ul>
            );
        }

        return (<> </>);
    }

    renderCatPadresOriginal() {
        const {
            padres
        } = this.props;

        return (
            <div block="Menu" elem="Padres" className="Original">
                <ul
                  block="Menu"
                  key="padres"
                  elem="ItemList"
                  mods={ { type: 'main' } }
                  className="CatPadres"
                >
                    { padres.map(this.renderFirstLevelYB.bind(this)) }
                </ul>
            </div>
        );
    }

    renderCatPadresSlider() {
        const {
            padres
        } = this.props;

        return (
            <div block="Menu" elem="Padres">
                <div
                  block="Menu"
                  key="padres"
                  elem="ItemList"
                  mods={ { type: 'main' } }
                  className="CatPadres"
                >
                    <Swiper
                      navigation
                      modules={ [Navigation] }
                      spaceBetween={ 0 }
                      slidesPerView="auto"
                      initialSlide={ 0 }
                    >
                        { padres.map((cat) => (
                            this.renderSliderPadresYB(cat)
                        )) }
                    </Swiper>
                </div>
                <div id="categoriasHijasPadres">
                    { padres.map((cat) => (this.renderCatHijasPadres(cat))) }
                </div>
            </div>
        );
    }

    renderCategoryImage() {
        const { imagesPadres, catHijaPadreMostrada } = this.props;

        return (
            <div block="Menu" elem="ImagesPadres">
                { imagesPadres.map((cat) => (
                    <Link
                      key={ cat.cat_id }
                      to={ cat.url }
                      block="Menu"
                      elem="Link"
                      id={ cat.cat_id }
                      className={ catHijaPadreMostrada === cat.cat_id ? ' mostrando' : 'oculta' }
                    >
                        <Image src={ cat.cat_img } />
                    </Link>
                )) }
            </div>
        );
    }

    renderCatNoPadres() {
        const { noPadres } = this.props;

        return (
            <div block="Menu" elem="NoPadres">
                <ul
                  key="noPadres"
                  block="Menu"
                  elem="ItemList"
                  mods={ { type: 'main' } }
                >
                    { noPadres.map(this.renderFirstLevelYB.bind(this)) }
                </ul>
            </div>
        );
    }

    renderAccountButton() {
        const { onSignInAccountButtonClick } = this.props;

        return (
            <div
              block="Menu"
              elem="SignInAccountButton"
              onClick={ onSignInAccountButtonClick }
              onKeyUp={ () => {} }
            >
                <FontAwesomeIcon icon={ faUser } />
                <span>{ isSignedIn() ? __('My Account') : __('Sign in') }</span>
            </div>
        );
    }

    renderLanguageButton() {
        return (
            <div
              block="Menu"
              elem="LanguageButton"
            >
                <FontAwesomeIcon icon={ faGlobe } />
                <StoreSwitcher isMenuYB />
            </div>
        );
    }

    render() {
        const { isLoading, closeMenu, menuYB } = this.props;

        if (isLoading) {
            return (
                <>
                    <div
                      block="Menu"
                      elem="MenuWrapper"
                      onMouseLeave={ closeMenu }
                    >
                        <Loader isLoading={ isLoading } />
                    </div>
                    <div
                      block="Menu"
                      elem="MenuButtons"
                    >
                        { this.renderAccountButton() }
                        { this.renderLanguageButton() }
                    </div>
                </>
            );
        }
        if (menuYB) {
            // const { userAgent } = window.navigator;

            // if (userAgent.includes('app-pwa') || userAgent.includes('app-elganso')) {
            //     return (
            //         <>
            //             <div
            //               block="Menu"
            //               elem="MenuWrapper"
            //               onMouseLeave={ closeMenu }
            //               className={ isSignedIn() ? 'registrado' : '' }
            //             >
            //                 { this.renderCatPadresSlider() }
            //                 { this.renderCatNoPadres() }
            //                 { this.renderTopLevel() }
            //                 { this.renderCategoryImage() }
            //             </div>
            //             <div
            //               block="Menu"
            //               elem="MenuButtons"
            //             >
            //                 { this.renderAccountButton() }
            //                 { this.renderLanguageButton() }
            //             </div>
            //         </>
            //     );
            // }

            return (
                <>
                    <div
                      block="Menu"
                      elem="MenuWrapper"
                      onMouseLeave={ closeMenu }
                      className={ isSignedIn() ? 'Original registrado' : 'Original' }
                    >
                        { this.renderCatPadresOriginal() }
                        { this.renderCatNoPadres() }
                        { this.renderTopLevel() }
                    </div>
                    <div
                      block="Menu"
                      elem="MenuButtons"
                    >
                        { this.renderAccountButton() }
                        { this.renderLanguageButton() }
                    </div>
                </>
            );
        }

        return (
            <>
                <div
                  block="Menu"
                  elem="MenuWrapper"
                  onMouseLeave={ closeMenu }
                >
                    { this.renderTopLevel() }
                </div>
                <div
                  block="Menu"
                  elem="MenuButtons"
                >
                    { this.renderAccountButton() }
                    { this.renderLanguageButton() }
                </div>
            </>
        );
    }
}

export default MenuComponent;
